/**
 * $t('enum.E_EquipmentOrderBy.AlarmLevel')
 * $t('enum.E_EquipmentOrderBy.CustomSort')
 */
export enum E_EquipmentOrderBy {
    /**
     * 报警等级
     */
    AlarmLevel = 'AlarmLevel',
    /**
     * 自定义排序
     */
    CustomSort = 'CustomSort',
}


export type WithOrderNum<T> = T & {
    orderNum: number
}
